import { baseFormat, splitFormatAmount } from '@/utility/formatter';

// TODO: USe tailwind group:last-child
const alignmentStyle = {
  left: 'sm:tw-justify-start',
  center: 'sm:tw-justify-center',
  right: 'sm:tw-justify-end',
};

const InvestmentCardField = ({
  label,
  primaryValue,
  secondaryValue,
  withTypography = false,
  alignment = 'left',
  isAmount = true,
}) => {
  const hasPrimaryValue = primaryValue != null;

  const displayValue = hasPrimaryValue
    ? isAmount
      ? withTypography
        ? splitFormatAmount(primaryValue)
        : baseFormat(primaryValue)
      : primaryValue
    : null;

  return (
    <div
      className={`tw-flex xs:tw-flex-col tw-justify-between xs:tw-justify-start tw-text-sm tw-flex-wrap`}
    >
      <div
        className={`tw-flex tw-text-[#001316] tw-opacity-50 ${alignmentStyle[alignment] || alignmentStyle.left}`}
      >
        {label}
      </div>
      <div
        className={`tw-flex tw-gap-2 tw-justify-start ${alignmentStyle[alignment] || alignmentStyle.left} tw-items-end`}
      >
        {hasPrimaryValue ? (
          <>
            {isAmount && withTypography ? (
              <div className="">
                <span className="xs:tw-text-3xl">
                  {displayValue.symbol}
                  {displayValue.integer}.
                </span>
                <span className="sm:tw-text-xl">{displayValue.decimal || '00'}</span>
                {displayValue.notation}
              </div>
            ) : (
              <div className="sm:tw-text-xl">{displayValue}</div>
            )}
            {secondaryValue != null && (
              <div
                className={`sm:tw-pb-0.5 ${secondaryValue >= 0 ? 'tw-text-[#00B591]' : 'tw-text-[#E15A5A]'}`}
              >
                ({Number.parseFloat(secondaryValue).toFixed(2)}%)
              </div>
            )}
          </>
        ) : (
          <div
            className={`sm:tw-text-xl ${secondaryValue >= 0 ? 'tw-text-[#00B591]' : 'tw-text-[#E15A5A]'}`}
          >
            {secondaryValue != null ? `${Number.parseFloat(secondaryValue).toFixed(2)}%` : '-'}
          </div>
        )}
      </div>
    </div>
  );
};

export default InvestmentCardField;
